import { render, staticRenderFns } from "./PermissionTab.vue?vue&type=template&id=17a3b223"
import script from "./PermissionTab.vue?vue&type=script&lang=ts"
export * from "./PermissionTab.vue?vue&type=script&lang=ts"
import style0 from "./PermissionTab.vue?vue&type=style&index=0&id=17a3b223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports